import { defaultMemoize } from 'reselect';

export default defaultMemoize(({ firstName = '', middleName = '', lastName = '' }) => {
  return `${firstName} ${middleName ? middleName + ' ' : ''}${lastName}`;
});

export function concatAttendeeName(incomingName, nameToBeAdded) {
  return `${incomingName}, ${nameToBeAdded}`;
}

export function formatAttendeeNameFromResource({ firstName = '', lastName = '' }, translate) {
  return translate('EventWidgets_InviteeName__resx', { firstName, lastName });
}
